export interface UI2RendererMeta {
  isValueEmptyForRequired?: (value: any, props: any) => boolean
  getCountErrors?: (value: any, props: any) => string[] | undefined
  isolatesChildValueScope?: boolean
}

/**
 * Renderer metadata for each `ui2:` component type. The entity renderer reads
 * these instead of class statics, so the values survive HOC wrapping without
 * manual re-hoisting. Keyed by the exact `ui2:` type string from the schema.
 *
 * Guardrail: any component that carries renderer metadata must have an entry
 * here; the metadata test enforces this.
 */
export const UI2_RENDERER_META: Record<string, UI2RendererMeta> = {
  'ui2:form': {
    isolatesChildValueScope: true,
  },
  'ui2:formSection': {
    isolatesChildValueScope: true,
  },
}
